import React from "react";
import "./LetterAvatar.scss";

const LetterAvatar = ({
  name = "?",
  className = "",
  style = {},
  size,
  fontSize,
  radius,
}) => {
  const cleanName = (name || "").toString().trim();
  const initial = cleanName ? cleanName.charAt(0).toUpperCase() : "?";

  const containerStyle = { ...style };
  if (size !== undefined) {
    const sizeVal = typeof size === "number" ? `${size}px` : size;
    containerStyle.width = sizeVal;
    containerStyle.height = sizeVal;
  }
  if (radius !== undefined) {
    containerStyle.borderRadius =
      typeof radius === "number" ? `${radius}px` : radius;
  }

  const computedFontSize =
    fontSize !== undefined
      ? typeof fontSize === "number"
        ? `${fontSize}px`
        : fontSize
      : typeof size === "number"
      ? `${Math.round(size * 0.42)}px`
      : undefined;

  const spanStyle = computedFontSize ? { fontSize: computedFontSize } : undefined;

  return (
    <div
      className={`ls-letter-avatar ${className}`}
      style={containerStyle}
      aria-hidden="true"
    >
      <span style={spanStyle}>{initial}</span>
    </div>
  );
};

export default LetterAvatar;
